

var article = `
## Versión Enterprise o Ultimate

Para estas versiones simplemente se puede *descargar el idioma* desde el *centro de actualizaciones*.

Otra forma es ir al **Panel de control** > **Región e idioma**.

## Otras versiones de Windows 7

Las otras versiones **no** cuentan con la posibilidad de cambiar el idioma facilmente. Por lo tanto **hay que descargarlos**.

### Descargar paquetes de idiomas

**NOTA:** descargar según el sistema, hay paquetes para 32 bits y paquetes para 64 bits.

1. Acá hay un [enlace para descargar idiomas de Windows 7](https://taringa.net/+info/windows-7-mui-lenguaje-packs-oficiales-para-32-bit-y-64-bit_w2q0o). 

2. Acá hay paquetes de idioma español: 

	* [enlace de descarga de Español para 32 bits]( http://download.windowsupdate.com/msdownload/update/software/updt/2009/08/windows6.1-kb972813-x86-es-es_1943a073d8f00e387301deb22cd177bf77319ee8.exe)

	* [enlace de descarga de Español para 64 bits](http://download.windowsupdate.com/msdownload/update/software/updt/2009/08/windows6.1-kb972813-x64-es-es_2e593c26d9e23ad8176224a53c68a04f996ee014.exe)

Esto descargará un archivo ejecutable (**.exe**). 

Lo ejecuto, y en el mismo lugar aparecerá un archivo llamado **lp.cab** y *desaparecerá despues de unos segundos*. 

Hay que copiar el archivo **antes de que desaparezca** y pegarlo en otra parte, por ejemplo, el Escritorio.

Ahora sólo queda **instalarlo**.

### Instalar el idioma (.cab)

Las opciones que hay son:

1. Descargar el paquete del idioma e instalarlo con la aplicación **Virtualizator** para Windows 7.

2. Descargar el paquete del idioma e instalarlo por **CMD** / **Consola** (**recomendado**).

## 1. Instalar el idioma con Virtualizator

Virtualizartor es una aplicación para Windows 7 que permite instalar paquetes de idioma, pero *puede ser dañina para el sistema*, este es el [sitio oficial de Virtualizator] **no** es recomendado y la **instalación por CMD** funciona bien.

## 2. Instalar el idioma por CMD / Consola

Abrir el **CMD** como *administrador*. 

**NOTA:** debe ser con la aplicación **CMD** y no **PowerShell**.

* **Instrucciones para ingresar como administrador:** 
	* en el buscador de inicio buscar la palabra **cmd**.
	* *Segundo clic* en la aplicación **CMD** (ó también puede llamarse **Símbolo del sistema**) 
	* y elegir *Ejecutar como administrador*.


> dism /online /add-package /packagepath:**[acá va la ruta del paquete de idioma]**/lp.cab
      
> **Por ejemplo:** dism /online /add-package /packagepath:C:\\Users\\juan\\Desktop\\lp.cab

Presiono **Enter** y espero que se instale el paquete, despues de unos minutos aparecerá el mensaje de que se instaló correctamente.

**NOTA:** si hay problemas con ese comando, clic <a href="#titleProblemInstalarIdiomasWindows7">aquí</a>.

Luego escribimos los comandos (*por ejemplo*, para el paquete de Español):

> bcedit /ser {current} locale es-ES

> bcdboot %WinDir% /l es-ES
     
Después **reiniciamos** y se iniciará con el **nuevo idioma**.

<h2 id="titleProblemInstalarIdiomasWindows7">Problemas</h2>

En caso de tener problemas con el *primer comando*, ejecuto el *segundo comando* y luego elimino el paquete de idioma que estaba instalado por defecto: **Ingles (en-US)**.

Para eliminar el paquete de inglés, lo primero que tengo que hacer es una copia de respaldo con el programa [Erunt](https://es.ccm.net/download/descargar-370-erunt#q=erunt&cur=1&url=%2F) (**opcional**).

En la barra de búsqueda de inicio escribo **regedit**. Ejecutar y entrar a estas carpetas: 

* HKEY_LOCAL_MACHINE **/** 
* SYSTEM **/** 
* CurrentControlSet **/** 
* Control **/** 
* MUI **/** 
* UILanguages

Acá debería estar el directorio **en-US** y **es-ES**. 

Elimino el directorio **en-US**, clic derecho y selecciono *Eliminar*. **NO** la eliminemos si no existe el directorio **es-ES**.

Listo, después de reiniciar *debería iniciarse en español*.

`;

export default article;